import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';

function AdminDashboard() {
  const [stats, setStats] = useState({
    courses: 0,
    students: 0,
    feesCollected: 0,
    feesPending: 0
  });

  useEffect(() => {
    const sessionData = JSON.parse(sessionStorage.getItem('adminSession')) || {};
    const token = sessionData.token;
    if (token) {
      axios.get(`${process.env.REACT_APP_API_URL}/api/stats?nocache=${Date.now()}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(response => {
          console.log('API Response:', response.data);
          if (response.data.success) {
            setStats(response.data);
          } else {
            console.error('API Error:', response.data.message);
          }
        })
        .catch(error => {
          console.error('Error fetching stats:', error.response?.data || error.message);
        });
    } else {
      console.error('No token found in sessionStorage');
    }
  }, []);

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="row gy-4">
            <div className="col-xxl-8">
              <div className="card h-100">
                <div className="card-body grettings-box-two position-relative z-1 p-0">
                  <div className="row align-items-center h-100">
                    <div className="col-lg-6">
                      <div className="grettings-box-two__content">
                        <h2 className="fw-medium mb-0 flex-align gap-10">
                          Hi, Administrator{" "}
                          <img src="/assets/images/icons/wave-hand.png" alt="" />{" "}
                        </h2>
                        <h2 className="fw-medium mb-16">
                          Welcome to IFM EDU Learning Management System!
                        </h2>
                        <p className="text-15 text-gray-400">
                          Manage courses, track fees, and enhance best experience for
                          your students.
                        </p>
                        <a
                          href="/admin-view-course"
                          className="btn btn-main rounded-pill mt-32"
                        >
                          Explore Courses
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-6 d-md-block d-none mt-auto">
                      <img src="/assets/images/thumbs/gretting-thumb.png" alt="" />
                    </div>
                  </div>
                  <img
                    src="/assets/images/bg/star-shape.png"
                    className="position-absolute start-0 top-0 w-100 h-100 z-n1 object-fit-contain"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-xxl-4">
              <div className="row gy-4">
                <div className="col-sm-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="flex-between gap-8 mb-24">
                        <span className="flex-shrink-0 w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-2xl">
                          <i className="ph-fill ph-graduation-cap" />
                        </span>
                        <div
                          id="complete-course"
                          className="remove-tooltip-title rounded-tooltip-value"
                        ></div>
                      </div>
                      <h4 className="mb-2">{stats.courses}</h4>
                      <span className="text-gray-300">Our Courses</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="flex-between gap-8 mb-24">
                        <span className="flex-shrink-0 w-48 h-48 flex-center rounded-circle bg-main-two-600 text-white text-2xl">
                          <i className="ph-fill ph-graduation-cap" />
                        </span>
                        <div
                          id="earned-certificate"
                          className="remove-tooltip-title rounded-tooltip-value"
                        ></div>
                      </div>
                      <h4 className="mb-2">{stats.students}</h4>
                      <span className="text-gray-300">Our Students</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="flex-between gap-8 mb-24">
                        <span className="flex-shrink-0 w-48 h-48 flex-center rounded-circle bg-purple-600 text-white text-2xl">
                          <i className="ph-fill ph-certificate" />
                        </span>
                        <div
                          id="course-progress"
                          className="remove-tooltip-title rounded-tooltip-value"
                        ></div>
                      </div>
                      <h4 className="mb-2">{Math.round(stats.feesCollected)}</h4>
                      <span className="text-gray-300">Fees Collected</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="flex-between gap-8 mb-24">
                        <span className="flex-shrink-0 w-48 h-48 flex-center rounded-circle bg-warning-600 text-white text-2xl">
                          <i className="ph-fill ph-users-four" />
                        </span>
                        <div
                          id="community-support"
                          className="remove-tooltip-title rounded-tooltip-value"
                        ></div>
                      </div>
                      <h4 className="mb-2">{Math.round(stats.feesPending)}</h4>
                      <span className="text-gray-300">Fees Pending</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default AdminDashboard;